import { store } from '../store'

export default (to, from, next) => {
  if (store.getters.user && store.getters.company) {
    next()
  } else {
    next('/signin')
  }
}



// WEBPACK FOOTER //
// ./src/router/AuthGuard.js